import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Products } from "app/_models/products";
import { ToastrService } from "ngx-toastr";
import { CrudProductService } from "app/_services/MasterCrudOps/crud-product.service";
import { UserModel } from "app/_models/user-model";
declare const swal: any;

@Component({
  selector: "app-edit-product",
  templateUrl: "./edit-product.component.html",
  styleUrls: ["./edit-product.component.css"],
})
export class EditProductComponent implements OnInit {
  editProductForm: FormGroup;
  editProduct: Products;
  currentUser: UserModel;
  isAdminGroupUser:boolean = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly crudProductService: CrudProductService,
    private readonly dialogRef: MatDialogRef<EditProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Products
  ) {
    this.editProduct = data;
     this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }

  ngOnInit(): void {
    this.editProductForm = this.fb.group({
      productName: [
        this.data.productName ?? "",
        [Validators.required, Validators.maxLength(50)],
      ],
      description: [
        this.data.description ?? "",
        [Validators.required, Validators.maxLength(100)],
      ],
    });
  }

  saveProduct() {
    const productName = (this.editProductForm.value.productName ?? "").trim();
    const description = (this.editProductForm.value.description ?? "").trim();
    let errorMessage = "";

    if (!productName) {
      errorMessage += "Product Name is required.\n";
    }
    if (productName.length > 50) {
      errorMessage += "Product Name cannot be more than 50 characters.\n";
    }
    if (!description) {
      errorMessage += "Description is required.\n";
    }
    if (description.length > 100) {
      errorMessage += "Description cannot be more than 100 characters.\n";
    }

    if (errorMessage) {
      swal({
        title: "",
        text: errorMessage,
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
      return;
    }

    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Update IT!",
    }).then((result) => {
      if (result === true) {
        let model = {productId : this.editProduct.productId, productName :productName, description:description};
        this.updateProduct(model);
      } else {
        this.toastr.info("result not saved");
      }
    });
  }

  updateProduct(model:any) {
    this.crudProductService.updateProduct(model).subscribe(
      (data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          this.dialogRef.close(true);
        }
      },
      (error) => {
       let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }
        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
    
  }

  close() {
    this.dialogRef.close(true);
  }
}
